import { motion } from "framer-motion"

const testimonials = [
  {
    quote: "O que fez diferença foi ter professor real. Não sou eu sozinho na plataforma.",
    name: "Ana",
    age: "34 anos",
    role: "marketing digital",
    image: "https://images.pexels.com/photos/1181690/pexels-photo-1181690.jpeg?auto=compress&cs=tinysrgb&w=200",
    accent: "border-blue-500",
    bg: "bg-blue-50",
  },
  {
    quote: "Falei na primeira semana. Não precisei esperar 6 meses para abrir a boca.",
    name: "Roberto",
    age: "29 anos",
    role: "engenheiro",
    image: "https://images.pexels.com/photos/2182970/pexels-photo-2182970.jpeg?auto=compress&cs=tinysrgb&w=200",
    accent: "border-red-500",
    bg: "bg-red-50",
  },
  {
    quote: "A Lucy me salvou às 23h antes de uma reunião importante. Responde na hora.",
    name: "Fernanda",
    age: "31 anos",
    role: "consultora",
    image: "https://images.pexels.com/photos/1065084/pexels-photo-1065084.jpeg?auto=compress&cs=tinysrgb&w=200",
    accent: "border-blue-500",
    bg: "bg-blue-50",
  },
  {
    quote: "Fiz o teste de nível antes e depois. Subi do básico ao intermediário em 5 meses.",
    name: "Lucas",
    age: "27 anos",
    role: "analista financeiro",
    image: "https://images.pexels.com/photos/1516680/pexels-photo-1516680.jpeg?auto=compress&cs=tinysrgb&w=200",
    accent: "border-red-500",
    bg: "bg-red-50",
  },
]

function DetailedTestimonials() {
  return (
    <section className="bg-gray-50 py-14 sm:py-20 px-4">
      <div className="max-w-6xl mx-auto">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-2xl sm:text-3xl md:text-4xl font-bold text-center text-gray-900 mb-10"
        >
          A estrutura que já transformou milhares de alunos
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10">
          {testimonials.map((t, i) => (
            <motion.div
              key={t.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.12 }}
              className={`${t.bg} rounded-2xl p-6 border-l-4 ${t.accent}`}
            >
              <div className="flex items-center gap-4 mb-4">
                <img
                  src={t.image}
                  alt={t.name}
                  className={`w-14 h-14 rounded-full object-cover border-2 ${t.accent}`}
                />
                <div>
                  <p className="font-bold text-gray-900">{t.name}, {t.age}</p>
                  <p className="text-sm text-gray-500">{t.role}</p>
                </div>
              </div>
              <p className="text-gray-700 text-base italic">"{t.quote}"</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="text-center"
        >
          <a
            href="#cta-final"
            className="inline-block bg-red-600 text-white font-extrabold text-lg px-8 py-4 rounded-xl hover:bg-red-700 transition-colors animate-pulse-glow-red"
          >
            👉 Se eles conseguiram, eu também consigo
          </a>
        </motion.div>
      </div>
    </section>
  )
}

export default DetailedTestimonials
